import { render, staticRenderFns } from "./modal-header.vue?vue&type=template&id=54f50675&scoped=true"
import script from "./modal-header.vue?vue&type=script&lang=ts"
export * from "./modal-header.vue?vue&type=script&lang=ts"
import style0 from "./modal-header.vue?vue&type=style&index=0&id=54f50675&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f50675",
  null
  
)

export default component.exports